import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import type { SearchResult } from '@/src/components/global-search/types'
import { tokenId } from '@/src/components/global-search/types'

const MAX_SEARCH_HISTORY = 2

export type SearchHistoryItem = Omit<SearchResult, 'price' | 'change'>

const storageAtom = atomWithStorage<SearchHistoryItem[]>('search_history', [])

export const searchHistoryAtom = atom(
  (get) => get(storageAtom),
  (get, set, item: SearchResult) => {
    const { ...omittedItem } = item
    if (
      get(storageAtom).every(
        (search) => tokenId(search) !== tokenId(omittedItem),
      )
    ) {
      set(
        storageAtom,
        [omittedItem, ...get(storageAtom)].slice(0, MAX_SEARCH_HISTORY),
      )
    }
  },
)
